export default __webpack_public_path__ + "de51901e458afb178ac4c81b55753c4e.png";